import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { SupplierDto } from './supplier.dto';
import { SupplierRegionDto } from '../../supplier-region/dto/supplier-region.dto';
import { SupplierRepresentativeDto } from '../../supplier-representative/dto/supplier-representative.dto';

/**
 * Response of the composite supplier routes: the supplier with its region
 * and representative links. Representatives gate CAN_SEE_MATERIALS_DELIVERY
 * in the admin, so the final set is echoed back for confirmation.
 */
export class SupplierFullDto extends SupplierDto {
  @ApiProperty({ type: () => [SupplierRegionDto] })
  @Expose()
  supplierRegions!: SupplierRegionDto[];

  // Named after the Supplier entity relation (singular), which is what the
  // API serialises.
  @ApiProperty({ type: () => [SupplierRepresentativeDto] })
  @Expose()
  supplierRepresentative!: SupplierRepresentativeDto[];
}
